<h1 mat-dialog-title>Please Scan a QR-Code</h1>
<div mat-dialog-content align="center">
  <mat-form-field appearance="outline" class="url-field">
    <mat-label>URL</mat-label>
    <input cdkFocusInitial matInput [(ngModel)]="data.url">
  </mat-form-field>

  <div class="container">

    <!-- ngx-scanner-qrcode -->
    <ngx-scanner-qrcode #action="scanner" [config]="config" (event)="onEvent($event)"></ngx-scanner-qrcode>

    <!-- loading -->
    <p *ngIf="action.isLoading">⌛ Loading...</p>

  </div>

</div>
<div mat-dialog-actions align="center">
  <button mat-button (click)="close()">Ok</button>
</div>
